import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { ToastHost, setToastDurations } from './lib/toast';
import { api } from './lib/api';
import './lib/designerHost';   // v12.10.3 (BDR-016): T2 hosts the shared workflow designer
import './styles/tokens.css';
import './styles/global.css';
import './styles/tenant-surface.css';

// NT1: pull platform-owned toast durations at load (anonymous endpoint). Fire-and-forget;
// falls back to the seed defaults in toast.tsx if unavailable.
api.get<Partial<Record<'success' | 'info' | 'warning' | 'error', number>>>('/api/notifications/toast-durations')
  .then(setToastDurations)
  .catch(() => { /* keep seed defaults */ });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <ToastHost />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

// VoiceSpectrum.Web.T2 · v10.0.8.5 · 2026-05-17 · VoiceSpectrum AI
